// SelectDropdown.js
import React from "react";
import Select from "react-select";
import { Form } from "react-bootstrap";

const SelectDropdown = ({
  options = [],
  value,
  onChange,
  placeholder = "Select...",
  isClearable = true,
  isSearchable = true,
  label,
  controlId
}) => {
  return (
    <Form.Group controlId={controlId}>
      <Form.Label>{label}</Form.Label>
      <Select
        options={options}
        value={options.find(option => option.value === value) || null}
        onChange={onChange}
        isClearable={isClearable}
        placeholder={placeholder}
        isSearchable={isSearchable}
      />
    </Form.Group>
  );
};

export default SelectDropdown;
